<template>
    <div class="container-main">
        <!-- <iframe src="https://phet.colorado.edu/sims/html/build-an-atom/latest/build-an-atom_all.html" frameborder="0"></iframe> -->
        <div v-if="wall" @click="closeStudyGuide()" class="wall"></div>
        <div>
            <div class="card card-report bg-white" v-if="role_type == 'parent'">
                <div class="card-body parent-home" style="padding: 0;">

                    <div class="card-body-header">
                        <div class="title">{{ $t('complete') }}:</div>
                        <div class="tools" v-if="child_account.student_type != 0">
                            <router-link :to="{ name: 'grade_book' }" @click.native="getSoundClick">
                                <button class="btn btn-lisa-8">{{ $t('p_view_all') }}</button>
                            </router-link>
                        </div>
                    </div>
                    <!-- {{dataReport.report_total.subjects}} -->
                    <!-- <div class="card-body-content" style="padding-right:0" v-for="(sbj,index) in dataReport" v-bind:key="index">
                        <div class="card-body-content-1">{{$t(sbj.category_code)}}:</div>
                        <div class="card-body-content-2"><b>{{sbj.total}}</b> {{$t(sbj.unit_name)}}</div>
                        <div class="card-body-content-3">
                            <div class="progress" style="margin: 0;">
                                <div class="progress-bar"
                                     :style="{ width: calcPercent(sbj.completed,sbj.total) + '%' }"></div>
                            </div>
                        </div>
                        <div class="card-body-content-4"><b>{{sbj.completed}}</b> <span class="small">{{$t('of_1')}} {{sbj.total}} {{$t(sbj.unit_name)}}</span></div>
                    </div> -->
                    <div v-for="(sbj, i) in dataReport">
                        <h4 class="title" style="font-size: 18px;">{{ $t(`${sbj.code}`) }}</h4>
                        <div v-for="(sbj1, i1) in sbj.subjects">
                            <div v-for="(sbj2, i2) in sbj1.course">
                                <div class="info-item d-flex" style="margin-bottom: 12px; margin-left: 40px;">
                                    <div class="info-label" style="width: 150px; font-size: 14px; white-space: nowrap;">{{ sbj1.code != 'english' ? $t('p_subject_category_name_iSmart') + ": " + $t(sbj1.code) : $t(sbj2.unit_name) }}: </div>
                                    <div class="info-body">
                                        <div class="info-body-content d-flex" style="">
                                            <div class="info-body-2 d-flex">
                                                <div class="progress" style="width: 500px; margin-bottom: 0;">
                                                    <div class="progress-process" v-bind:style="{ width: calcPercent(sbj2.completed, sbj2.total) + '%' }">
                                                    </div>
                                                </div>
                                                <div class="info-body-3" style="white-space: nowrap; margin-left: 10px;">
                                                    <span class="number">{{ sbj2.completed }}</span>
                                                    {{ $t('of') }}
                                                    {{ sbj2.total }} {{ $t(`${sbj2.unit}`) }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="card-body-header" style="margin-top: 30px" v-if="child_account.student_type != 0">
                        <div class="title">{{ $t('p_skill_assessment') }}:</div>
                        <div class="tools">
                            <router-link :to="{ name: 'parent_feedback' }" @click.native="getSoundClick">
                                <button class="btn btn-lisa-8">{{ $t('p_view_all') }}</button>
                            </router-link>
                        </div>
                    </div>

                    <div class="card-body-skill-assessment" style="padding: 0 130px;">
                        <div class="row">
                            <div class="col-md-6 mb-32 d-flex" v-for="(skill, index) in skills" v-bind:key="index">
                                <template v-for="(s, i) in skill.max">
                                    <div class="reactange mr-4" v-if="i >= skill.value" v-bind:key="i"></div>
                                    <div class="reactange reactange-1 mr-4" v-else v-bind:key="i"></div>
                                </template>
                                <div class="text-capitalize" style="margin-left: 8px">{{ skill.skill_code }}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div v-if="role_type == 'student'">
                <!-- LiveClass -->
                <div class="card card-live-alert mt-20" style="margin-bottom: 20px" v-if="(this.user.student_type != 0 && (live_class_data.length > 0 || online_testing_data.length > 0 || list_events.length > 0))">
                    <!-- <div class="card card-live-alert mt-20" style="margin-bottom: 20px" v-if="true"> -->
                    <div class="card-body">
                        <h5 class="card-title">
                            <span class="title">{{ $t('learning_notifications') }}</span>
                            <!-- <div class="buttons" style="margin-left: 15px"> -->
                            <!-- <div class="btn-group"> -->
                            <!-- <button type="button"
                                            :class="notice == 'live_class' ? 'btn btn-default active' : 'btn btn-default'" @click="changeNotice()">
                                        Live class
                                    </button>
                                    <button type="button"
                                            :class="notice == 'online_testing' ? 'btn btn-default active': 'btn btn-default'" @click="changeNotice()">
                                        Online testing
                                    </button> -->
                            <div class="tools">
                                <nav class="ito-tabs">
                                    <a :class="notice == 'live_class' ? 'btn btn-default active' : 'btn btn-default'" @click="changeNotice('live_class')" style="cursor: pointer">{{ $t('live_class') }}</a>
                                    <a :class="notice == 'online_testing' ? 'btn btn-default active' : 'btn btn-default'" @click="changeNotice('online_testing')" style="cursor: pointer">{{ $t('online_testing') }}</a>
                                    <a :class="notice == 'events' ? 'btn btn-default active' : 'btn btn-default'" @click="changeNotice('events')" style="cursor: pointer">{{ $t('English Champion') }}</a>
                                </nav>
                            </div>
                            <!-- </div> -->
                            <!-- </div> -->
                        </h5>
                        <div class="card-content" style="background: #F8F8F8;">
                            <div id="swiper-live-class" class="swiper mySwiper" v-if="notice == 'live_class' && live_class_data.length > 0">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="(tutoring, index) in live_classes.filter(i => i.status != 4)" v-bind:key="index">
                                        <div class="card-live-alert-item">
                                            <div class="title">{{ tutoring.time_start | convertUnitToTime('ddd') }} - {{ tutoring.time_start | convertUnitToTime('HH:mm') }} {{ $t('to') }} {{ tutoring.time_end | convertUnitToTime('HH:mm') }}
                                                <div style="display:inline-block" v-if="tutoring.status == 2">
                                                    <span class="live-class-dot"></span><span class="live-class-text">{{ $t('live_now_2') }}</span>
                                                </div>
                                            </div>

                                            <p class="desc"><b>{{ $t('class') }}: </b> <span class="underline"><b>{{ tutoring.class_name }}</b></span></p>
                                            <p class="desc"><b>{{ $t('subject') }}: </b> <span class="underline"><b>{{ tutoring.subject }}</b></span></p>
                                            <p class="desc"><b>{{ $t('teacher') }}: </b> <span class="underline"><b>{{ tutoring.teacher }}</b></span></p>

                                            <div style="margin-top: 16px">
                                                <button class="btn btn-join-class" @click="btnJoinClass(tutoring.start_url)" v-if="tutoring.status == 2" style="padding: 4px 25px;  width: 100%">{{ $t('lisa_web_join_to_class') }}</button>
                                                <button class="btn btn-class-finish" v-if="tutoring.status == 1" style="padding: 4px 25px;  width: 100%">{{ $t('lisa_web_class_comming') }}:
                                                    <countdown style="margin-left:5px" :toturing="tutoring" :key="tutoring.id" />
                                                </button>
                                            </div>
                                            <!-- <CountdownCloseClass :tutoring = "tutoring" /> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-button-next" v-if="notice == 'live_class' && live_class_data.length > 2">
                                    <img src="/themes/ito/images/live-class-next.svg" alt="">
                                </div>
                                <div class="swiper-button-prev" v-if="notice == 'live_class' && live_class_data.length > 2">
                                    <img src="/themes/ito/images/live-class-prev.svg" alt="">
                                </div>
                            </div>
                            <div id="swiper-live-class" class="swiper mySwiper" v-if="notice == 'live_class' && live_class_data.length == 0">
                                <p class="no-availabel-text">{{ $t('lisa_web_empty_class') }}</p>
                            </div>
                            <div id="swiper-online-testing" class="swiper mySwiper" v-if="notice == 'online_testing' && online_testing_data.length > 0">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="(testing, index) in online_testing_data" v-bind:key="index">
                                        <div class="card-live-alert-item">
                                            <div class="title">{{ $t('from') }} {{ testing.start }} {{ $t('to') }} {{ testing.end }}</div>

                                            <p class="desc"><b style="text-transform: uppercase;">{{ testing.name }}</b></p>
                                            <p class="desc"><b>{{ $t('subject') }}: </b> <span class="underline"><b>{{ $t(testing.subject) }}</b></span></p>

                                            <div style="margin-top: 16px">
                                                <button class="btn btn-join-class" @click="btnDoTest(testing.url)" style="padding: 4px 25px;  width: 100%">{{ $t('do_test') }}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-button-next" v-if="notice == 'online_testing' && online_testing_data.length > 2">
                                    <img src="/themes/ito/images/live-class-next.svg" alt="">
                                </div>
                                <div class="swiper-button-prev" v-if="notice == 'online_testing' && online_testing_data.length > 2">
                                    <img src="/themes/ito/images/live-class-prev.svg" alt="">
                                </div>
                            </div>
                            <div id="swiper-online-testing" class="swiper mySwiper" v-if="notice == 'online_testing' && online_testing_data.length == 0">
                                <p class="no-availabel-text">{{ $t('lisa_web_empty_test') }}</p>
                            </div>

                            <div id="swiper-event" class="" v-if="notice == 'events' && list_events.length > 0">
                                <div class="" v-for="(event, index) in list_events" v-bind:key="index">
                                    <div class="title">{{ $t('from') }} {{ event.start }} {{ $t('to') }} {{ event.end }}</div>

                                    <p class="desc"><b style="text-transform: uppercase;">{{ event.name }}</b></p>
                                    <p class="desc"><b>{{ $t('ec_exam_desc') }}: </b> <span class="underline"><b>{{ $t(event.subject) }}</b></span></p>

                                    <!-- <div style="margin-top: 16px">
                                        <button class="btn btn-join-class" @click="btnDoTest(event.url)" style="padding: 4px 25px;  width: 100%">{{ $t('do_test') }}</button>
                                    </div>             -->

                                    <div style="margin-top: 30px">
                                        <button v-if="event.time_remaining != 0" class="btn btn-class-finish" style="padding: 4px 25px;  width: 100%">{{ $t('ec_exam_open_in') }}: {{ countdownFormatted }}</button>
                                        <button v-else class="btn btn-class-finish" style="padding: 4px 25px;  width: 100%; background: linear-gradient(180deg, #A7DF3D 0%, #96DB16 100%);" @click="btnDoTest(event.url)">{{ $t('btn_do_ec_exam') }}:</button>
                                    </div>
                                </div>
                                <div style="display: flex; justify-content: flex-end; flex: 1">
                                    <img src="https://s3-ec.s3.ap-southeast-1.amazonaws.com/assets/ec-banner.png" alt="" />
                                </div>
                            </div>
                            <div id="swiper-online-testing" class="" v-if="notice == 'events' && list_events.length == 0">
                                <p class="no-availabel-text">{{ $t('No event') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- EndLiveClass -->
                <div>
                    <div id="box-filter-c" class="container1">
                        <div id="filter-fixed" class="">
                            <div class="tools" style="margin-top: 30px;">
                                <nav class="ito-tabs">
                                    <template v-for="(p, index) in programs">
                                        <a v-if="p.code != system && isShowCourse(p)" v-bind:key="index" :class="program.code == p.code ? 'btn btn-default active' : 'btn btn-default'" @click="changeProgram(p)" style="cursor: pointer">
                                            <span>{{ $t(`${p.code}`) }} </span>
                                        </a>
                                        <span v-else-if="p.code == system && isShowCourse(p)">
                                            <a :class="program.code == p.code && program.subject == 'math' ? 'btn btn-default active' : 'btn btn-default'" @click="changeProgram(p, 'math', true)" style="cursor: pointer">
                                                <span>{{ $t('p_subject_category_name_iSmart') }}: {{ $t('math') }}</span>
                                            </a>
                                            <a :class="program.code == p.code && program.subject == 'science' ? 'btn btn-default active' : 'btn btn-default'" @click="changeProgram(p, 'science', true)" style="cursor: pointer">
                                                <span>{{ $t('p_subject_category_name_iSmart') }}: {{ $t('science') }}</span>
                                            </a>
                                        </span>
                                    </template>
                                </nav>
                            </div>
                            <!-- <div  class="box-filter">
                                <div class="box-filter-program">
                                    <div class="options">
                                        <div class="">
                                            <div class="show-course" @click="showSelectProgramForm">
                                                <img src="/themes/ito/images/icon-program.svg" alt="" />
                                                <p>{{$t('program')}} {{program.name}}</p>
                                                <img src="/themes/ito/images/icon-menu.svg" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="box-filter-detail" v-if="program.code != 'ket2'">
                                    <ul>
                                        <li  v-if="program.code != 'ket2' && program.code != 'precourse'">
                                            <div class="checkbox">
                                                <input type="checkbox" :id="'checkbox-99'" v-model="isShowLastestStudy"/>
                                                <label id="test" :for="'checkbox-99'">{{ $t("last_study") }}</label>
                                            </div>
                                        </li>
                                        <li v-for="(subject, index) in subjects" v-bind:key="index">
                                            <div class="checkbox" v-if="subject.program == program.code">
                                                <input type="checkbox" :id="'checkbox-'+subject.id" v-model="subject.is_checked"
                                                    @change="selectSubject(subject)"/>
                                                <label id="test" :for="'checkbox-'+subject.id">{{$t(program.name)}}: {{subject.name}}</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>                     -->
                        </div>
                    </div>
                    <div id="p_scroll1" class="" style="height: 100vh;">
                        <div class="nano-content1">
                            <!-- <div class="card" v-for="last in lastests" v-if="isShowLastestStudy && lastests.length != 0 && program.code != 'precourse' && program.code != 'ket2' && last.program == program.code && last.category_code == selectedSubject">
                                <div class="card-header">
                                    <div class="card-title">{{ $t("last_study") }}</div>
                                    <div class="card-desc-right">
                                        <b>{{last.time_ago_txt}}</b> {{ $t("at") }} {{last.time_txt}}
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <a href="#">
                                                <div class="thumb r16x9">
                                                    <div class="thumb-content">
                                                        <img class="thumb-img" :src="last.image" alt=""/>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="last-study-title">
                                                <router-link
                                                        :to="{path:'/lesson/' +last.subject_id +'-' +last.unit_id +'-' +last.lesson_id,}">
                                                    {{last.name_unit}}: {{last.title_unit}}
                                                </router-link>
                                            </div>
                                            <div class="last-study-desc">
                                                {{last.name_lesson}}: {{last.title_lesson}}
                                            </div>
                                            <div class="last-study-tools">
                                                <router-link v-if="last.category_code == 'ket2'"
                                                        :to="{path:'/ielts-item/' +last.subject_id +'-' +last.unit_id +'-' +last.lesson_id,}">
                                                    <button class="btn btn-main">{{ $t("continue_txt") }}</button>
                                                </router-link>
                                                <router-link v-else-if="last.category_code == 'precourse'"
                                                        :to="{path:'/pre-item/' +last.subject_id +'-' +last.unit_id +'-' +last.lesson_id,}">
                                                    <button class="btn btn-main">{{ $t("continue_txt") }}</button>
                                                </router-link>
                                                <router-link v-else
                                                        :to="{path:'/lesson/' +last.subject_id +'-' +last.unit_id +'-' +last.lesson_id,}">
                                                    <button class="btn btn-main">{{ $t("continue_txt") }}</button>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                            <div class="course-block">
                                <template v-for="(subject, index) in subjectData" v-if="isShowSubject(subject)">
                                    <!-- <div class="card" v-if="checkedSubjects.includes(subject.category_code) && subject.require_subject == 0 && subject.id > 0" v-bind:key="index"> -->
                                    <div class="card" v-if="(selectedSubject == 'all' ? true : subject.category_code == selectedSubject) && subject.require_subject == 0 && subject.id > 0" v-bind:key="index">
                                        <div class="card-header d-flex justify-content-between" v-if="subject.program != 'Eng_Test_Prep'">
                                            <div class="card-title">{{ $t("config_" + subject.category_code) }}</div>
                                            <div class="d-flex align-items-center">
                                                <!-- <router-link :to="{ path: '/final-test/' + user.grade + '/' + subject.subject_id }"
                                            v-if="subject.show_final_test == 1 && subject.is_completed == 1 && subject.program == system">
                                                <button class="last-study-button ebook-link" style="margin-top: 0;font-size: 14px; margin-right: 10px; border: none;">
                                                <img style="margin-right: 8px;" src="/themes/web/assets/images/lesson/ebook1.svg">
                                                {{$t('do_final_test') }}
                                                </button>
                                            </router-link>
                                            <button class="last-study-button ebook-link" v-if="subject.show_final_test == 0 && subject.program == system" style="margin-top: 0;font-size: 14px; margin-right: 10px; border: none;">
                                                <img style="margin-right: 8px;" src="/themes/web/assets/images/lesson/ebook1.svg">
                                                {{ $t('final_test_passed') }}
                                            </button> -->

                                                <!-- <a v-if="user_info.account_type != 1 && subject.program != 'precourse'" :href="'/ebook-home?subject=' + subject.category_code + '&grade_id=' + user.grade" target="_blank"  -->
                                                <a v-if="user_info.account_type != 1 && subject.program != 'precourse'" :href="'/ebook/' + subject.units[0].id" target="_blank" @click="handleGACustomEvent('IP2_W_1000', subject.id)" class="ebook-link"
                                                    style="text-decoration: none; font-weight: 600;">
                                                    <img src="/themes/web/assets/images/lesson/ebook1.svg">
                                                    <span style="margin-left: 5px">{{ $t('ebook_digital') }}</span>
                                                    <span v-if="true" style="margin-left: 8px; font-size: 12px;"></span>
                                                </a>

                                                <div v-if="subject.study_guide_picture_url" class="ebook-link" style="text-decoration: none; font-weight: 600; margin-left: 10px; cursor: pointer;" @click="openStudyGuide(subject)">
                                                    <img src="/themes/web/assets/images/lesson/icon-guide.svg">
                                                    <span style="margin-left: 5px">{{ $t('study_guide') }}</span>
                                                    <span v-if="true" style="margin-left: 8px; font-size: 12px;"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-header" v-else style="justify-content: space-between;">
                                            <div class="card-title">{{ subject.subject_name + " " + user.grade }}</div>

                                            <!-- <div class="ebook-link" style="text-decoration: none; font-weight: 600; margin-left: 10px; cursor: pointer;" @click="openStudyGuide(subject.program)">
                                            <img src="/themes/web/assets/images/lesson/icon-guide.svg">
                                            <span style="margin-left: 5px">{{$t('study_guide')}}</span>
                                            <span v-if="true" style="margin-left: 8px; font-size: 12px;"></span>
                                        </div> -->
                                        </div>
                                        <div class="card-body">
                                            <div style="grid-column: 1 / -1; padding: 20px 0;" v-for="last in lastests"
                                                v-if="isShowLastestStudy && lastests.length != 0 && program.code != 'precourse' && program.code != 'Eng_Test_Prep' && last.program == program.code && last.category_code == selectedSubject">
                                                <div style="display: flex; color: #000; margin-bottom: 20px; align-items: center;">
                                                    <div style="font-size: 25px; font-weight: 1000;">{{ $t("last_study") }}</div>
                                                    <div class="card-desc-right" style="font-size: 12px; margin-left: 8px; margin-top: 2px;">
                                                        ({{ last.time_ago_txt }} {{ $t("at") }} {{ last.time_txt }})
                                                    </div>
                                                </div>
                                                <div style="display: flex; ">
                                                    <div class="" style="margin-right: 30px;">
                                                        <a href="#">
                                                            <div class="thumb r16x10">
                                                                <div class="thumb-content">
                                                                    <img class="thumb-img" :src="last.image" style="border-radius: 4px;" alt="" />
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div class="">
                                                        <div class="last-study-title">
                                                            <router-link :to="{ path: '/lesson/' + last.subject_id + '-' + last.unit_id + '-' + last.lesson_id, }">
                                                                {{ last.name_unit }}: {{ last.title_unit }}
                                                            </router-link>
                                                        </div>
                                                        <div class="last-study-desc">
                                                            {{ last.name_lesson }}: {{ last.title_lesson }}
                                                        </div>
                                                        <div class="last-study-tools">
                                                            <router-link v-if="last.category_code == 'Eng_Test_Prep'" :to="{ path: '/ielts-item/' + last.subject_id + '-' + last.unit_id + '-' + last.lesson_id, }">
                                                                <button class="btn btn-main">{{ $t("continue_txt") }}</button>
                                                            </router-link>
                                                            <router-link v-else-if="last.category_code == 'precourse'" :to="{ path: '/pre-item/' + last.subject_id + '-' + last.unit_id + '-' + last.lesson_id, }">
                                                                <button class="btn btn-main">{{ $t("continue_txt") }}</button>
                                                            </router-link>
                                                            <router-link v-else :to="{ path: '/lesson/' + last.subject_id + '-' + last.unit_id + '-' + last.lesson_id, }">
                                                                <button class="btn btn-main">{{ $t("continue_txt") }}</button>
                                                            </router-link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <template v-for="(unit, index) in subject.units">
                                                <!-- {{programSelected.code}} -->
                                                <!--<template v-if="program.code == unit.program">-->
                                                <template v-if="program.code == 'Eng_Test_Prep'">
                                                    <div class="course-item" v-if="unit.status == 0" v-bind:key="index">
                                                        <div @click="gotoUnit(subject, unit.id)" :to="{ path: '/ielt/' + subject.id + '/' + unit.id + '/1' }">
                                                            <div class="thumb-study">
                                                                <div class="thumb r16x9">
                                                                    <div class="thumb-content">
                                                                        <img class="thumb-img" :src="unit.image" alt="" />
                                                                    </div>
                                                                    <!-- <div class="thumb-desc text-right">
                                                                        <div class="thumb-desc-title">{{ unit.title }}</div>
                                                                        <div class="thumb-desc-time">{{ timeConverter(unit.public_to) }}</div>
                                                                    </div> -->
                                                                </div>

                                                                <div class="thumb-study-thumb-info">
                                                                    <a class="thumb-study-thumb-info-title" href="#">
                                                                        <h4>{{ unit.name }}</h4>
                                                                    </a>
                                                                    <div class="thumb-study-thumb-info-desc progressing" v-if="unit.process != unit.total">
                                                                        {{ $t("complete") }} {{ unit.process }} {{ $t("complete_of") }} {{
                                                                            unit.total }}
                                                                    </div>
                                                                    <div class="thumb-study-thumb-info-desc" v-if="unit.process == unit.total">
                                                                        <img src="/themes/ito/images/icon-check.svg" alt="">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="course-item" v-if="unit.status == 1" v-bind:key="index">
                                                        <div class="lock-unit" @click="(user.student_type != 2) ? upgradeAccount(user.student_type) : ''">
                                                            <div class="thumb-study">
                                                                <div class="thumb r16x9">
                                                                    <div class="thumb-content">
                                                                        <img class="thumb-img" :src="unit.image" alt="" />
                                                                    </div>
                                                                    <!--<div class="thumb-desc text-right">-->
                                                                    <!--<div class="thumb-desc-title">{{ unit.title }}</div>-->
                                                                    <!--<div class="thumb-desc-time">{{ unit.title }}</div>-->
                                                                    <!--</div>-->
                                                                </div>

                                                                <div class="thumb-study-thumb-info">
                                                                    <a class="thumb-study-thumb-info-title" href="#">
                                                                        <h4>{{ unit.name }}</h4>
                                                                    </a>
                                                                    <div class="thumb-study-thumb-info-desc progressing">
                                                                        {{ $t("complete") }} {{ unit.process }} {{ $t("complete_of") }} {{
                                                                            unit.total }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <img class="lock-image" src="themes/web/assets/images/icons/lock.svg" />
                                                        </div>
                                                    </div>
                                                </template>

                                                <template v-else-if="programSelected.code == 'precourse'">
                                                    <div class="course-item" v-if="unit.status == 0" v-bind:key="index">
                                                        <div @click="gotoUnit(subject, unit.id)" :to="{ path: '/pre/' + subject.id + '/' + unit.id + '/1' }">
                                                            <div class="thumb-study">
                                                                <div class="thumb r16x9">
                                                                    <div class="thumb-content">
                                                                        <img class="thumb-img" :src="unit.image" alt="" />
                                                                    </div>
                                                                    <!-- <div class="thumb-desc text-right">
                                                                        <div class="thumb-desc-title">{{ unit.title }}</div>
                                                                        <div class="thumb-desc-time">{{ timeConverter(unit.public_to) }}</div>
                                                                    </div> -->
                                                                </div>

                                                                <div class="thumb-study-thumb-info">
                                                                    <a class="thumb-study-thumb-info-title" href="#">
                                                                        <!-- <h4>{{ unit.name }}</h4> -->
                                                                        <h4>{{ unit.title }}</h4>
                                                                    </a>
                                                                    <div class="thumb-study-thumb-info-desc progressing" v-if="unit.process != unit.total">
                                                                        {{ $t("complete") }} {{ unit.process }} {{ $t("complete_of") }} {{
                                                                            unit.total }}
                                                                    </div>
                                                                    <div class="thumb-study-thumb-info-desc" v-if="unit.process == unit.total">
                                                                        <img src="/themes/ito/images/icon-check.svg" alt="">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="course-item" v-if="unit.status == 1" v-bind:key="index">
                                                        <div class="lock-unit" @click="(user.student_type != 2) ? upgradeAccount(user.student_type) : ''">
                                                            <div class="thumb-study">
                                                                <div class="thumb r16x9">
                                                                    <div class="thumb-content">
                                                                        <img class="thumb-img" :src="unit.image" alt="" />
                                                                    </div>
                                                                    <!--<div class="thumb-desc text-right">-->
                                                                    <!--<div class="thumb-desc-title">{{ unit.title }}</div>-->
                                                                    <!--<div class="thumb-desc-time">{{ unit.title }}</div>-->
                                                                    <!--</div>-->
                                                                </div>

                                                                <div class="thumb-study-thumb-info">
                                                                    <a class="thumb-study-thumb-info-title" href="#">
                                                                        <!-- <h4>{{ unit.name }}</h4> -->
                                                                        <h4>{{ unit.title }}</h4>
                                                                    </a>
                                                                    <div class="thumb-study-thumb-info-desc progressing">
                                                                        {{ $t("complete") }} {{ unit.process }} {{ $t("complete_of") }} {{
                                                                            unit.total }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <img class="lock-image" src="themes/web/assets/images/icons/lock.svg" />
                                                        </div>
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    <div class="course-item" v-if="unit.status == 0" v-bind:key="index">
                                                        <!-- <div class="course-item" v-if="index == 0" v-bind:key="index"> -->
                                                        <div @click="gotoUnit(subject, unit.id)" :to="{ path: '/unit/' + subject.id + '/' + unit.id + '/1' }">
                                                            <div class="thumb-study">
                                                                <div class="thumb r16x9">
                                                                    <div class="thumb-content">
                                                                        <img class="thumb-img" :src="unit.image" alt="" />
                                                                    </div>
                                                                    <!-- <div class="thumb-desc text-right">
                                                                        <div class="thumb-desc-title">{{ unit.title }}</div>
                                                                        <div class="thumb-desc-time">{{ timeConverter(unit.public_to) }}</div>
                                                                    </div> -->
                                                                </div>

                                                                <div class="thumb-study-thumb-info">
                                                                    <a class="thumb-study-thumb-info-title" href="#">
                                                                        <h4>{{ unit.title }}</h4>
                                                                    </a>
                                                                    <div class="thumb-study-thumb-info-desc progressing" v-if="unit.process != unit.total">
                                                                        {{ $t("complete") }} {{ unit.process }} {{ $t("complete_of") }} {{
                                                                            unit.total }}
                                                                    </div>
                                                                    <div class="thumb-study-thumb-info-desc" v-if="unit.process == unit.total">
                                                                        <img src="/themes/ito/images/icon-check.svg" alt="">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="course-item" v-if="unit.status == 1" v-bind:key="index">
                                                        <!-- <div class="course-item" v-else> -->
                                                        <div class="lock-unit" @click="(user.student_type != 2) ? upgradeAccount(user.student_type) : ''">
                                                            <div class="thumb-study">
                                                                <div class="thumb r16x9">
                                                                    <div class="thumb-content">
                                                                        <img class="thumb-img" :src="unit.image" alt="" />
                                                                    </div>
                                                                    <!--<div class="thumb-desc text-right">-->
                                                                    <!--<div class="thumb-desc-title">{{ unit.title }}</div>-->
                                                                    <!--<div class="thumb-desc-time">{{ unit.title }}</div>-->
                                                                    <!--</div>-->
                                                                </div>

                                                                <div class="thumb-study-thumb-info">
                                                                    <a class="thumb-study-thumb-info-title" href="#">
                                                                        <h4>{{ unit.title }}</h4>
                                                                    </a>
                                                                    <div class="thumb-study-thumb-info-desc progressing">
                                                                        {{ $t("complete") }} {{ unit.process }} {{ $t("complete_of") }} {{
                                                                            unit.total }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <img class="lock-image" src="themes/web/assets/images/icons/lock.svg" />
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="card" v-else-if="checkedSubjects.includes(subject.category_code) && subject.require_subject == 1" v-bind:key="index">
                                        <div class="card-header">
                                            <div class="card-title">{{ $t("english") }}</div>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="coming-soon">
                                                        {{ $t("coming_soon") }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card" v-else-if="checkedSubjects.includes(subject.category_code) && subject.require_subject == 2" v-bind:key="index">
                                        <div class="card-header">
                                            <div class="card-title"> {{ $t("vi") }}</div>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="placement-test">
                                                        <div class="placement-test-desc">
                                                            <div style="margin-bottom: 18px;">
                                                                {{ $t('become_premium') }}
                                                            </div>
                                                            <div>
                                                                <a href="/upgrade-account">
                                                                    <button class="btn btn-main">{{ $t("upgrade_account") }}</button>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

            <div class="modal fade modal-flex" id="selectProgramModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="exchangeGiftModal" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $t('lisa_web_all_programs') }}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="">
                                <div class="" v-for="(p, index) in programs" v-bind:key="index">
                                    <div :class="getProgramClass(p, index)" @click="selectProgram(p)">
                                        <div class="title">
                                            {{ p.name }}
                                        </div>
                                        <img src="/themes/ito/images/icon-tick.svg" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-confirm m-auto" style="padding: 8px 57px;" @click="saveProgram">{{ $t('confirm') }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="popupUpgradeAccount" tabindex="-1" role="dialog" aria-labelledby="popupUpgradeAccount">
            <div class="modal-dialog modal-dialog-centered popup-main-2" role="document">
                <div class="modal-content box-shadow-main" style="padding: 20px 10px 30px;">
                    <h3 class="popup-title mb-20">{{ $t("lisa_web_require_upgrade") }}</h3>
                    <p class="txt-popup">
                        {{ $t("you_need_to_upgrade_your_account_to_get_full_course") }}

                    </p>
                    <!-- <div v-if="user.placement_test == 0">
                        <div @click="doTest()" class="lisa-btn-small active mt-3" data-bs-dismiss="modal" style="width: 160px; margin: auto" >
                            {{$t("upgrade_account")}}
                        </div>
                    </div> -->
                    <router-link :to="{ path: '/upgrade-account' }">
                        <div class="lisa-btn-small active mt-3" data-bs-dismiss="modal" style="width: 160px; margin: auto">
                            {{ $t("upgrade_account") }}
                        </div>
                    </router-link>

                    <!--<div class="ito-btn-small active mt-3" style="width: 160px; margin: auto">-->
                    <!--Upgrade account-->
                    <!--</div>-->
                    <div class="lisa-btn-small mt-3" data-bs-dismiss="modal" style="margin: auto">
                        {{ $t("cancel") }}
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="popupContinueLesson" data-bs-backdrop='static' tabindex="-1" role="dialog" aria-labelledby="popupContinueLesson">
            <div class="modal-dialog modal-dialog-centered popup-main-2" role="document">
                <div class="modal-content box-shadow-main" style="padding: 20px 10px 30px;">
                    <button type="button" @click="hidePopupFunct()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    <h3 class="popup-title mb-20" style="font-size: 22px;">{{ $t("comeback") }}</h3>
                    <img style="width: 80px; margin: auto;" src="/themes/web/assets/images/light.svg" alt="" />
                    <p class="txt-popup" style="font-size: 14px; text-align: center; margin-top: 15px;">
                        {{ $t('desc_comeback_1') }} <br>
                        {{ $t('desc_comeback_2') }}
                    </p>
                </div>
            </div>
        </div>


        <div v-if="wall" id="study_guide">
            <div class="modal-dialog">
                <div class="modal-content" style="width: 1150px; margin: auto; margin-top: 80px;">
                    <img style="width: 80px; margin: auto; height:unset; width: 25px; top: 10px; right: 10px" @click="closeStudyGuide()" class="close-study" src="/themes/web/assets/images/close-study-guide.svg" alt="" />
                    <div class="modal-body">
                        <img alt="" :src="url_study">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import {
    getCheckedSubjects,
    getConfigs,
    pushQueries,
    updateCheckedSubjects,
    soundClick,
    toPercent,
    generateJWT
} from "../utils/utils";
import { getAllUnit, getAllLastest, getListUnit, getOnlineTestDataOTV2, getOnlineTestData, getEvents } from "../models/dashboard";
import DailyBonusModal from "./modal/DailyBonusModal";
import { mapGetters } from 'vuex';
import GetRewardModal from "./modal/GetRewardModal";
import { getClassess, getTutorings, getTutoringsInComming } from "../models/live_class";
import Countdown from './element/Countdown.vue';
import CountdownCloseClass from './element/CoundownCloseClass.vue';
import { getParentReportGrade } from "../models/parent";
import { getParentFeedbacks } from "../models/feedback";
import { getOnlineTesting, getOnlineTestingV2 } from "../models/tutoring"
import { KJUR } from 'jsrsasign';



export default {
    name: "Welcome",
    components: { GetRewardModal, DailyBonusModal, Countdown, CountdownCloseClass },
    title: "Trang chủ",
    // props: ["user_info"],

    data() {
        return this.initState();
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        }),
        user() {
            return this.$store.state.user_info;
        },
        config() {
            return this.$store.state.configs;
        },
        live_class_data() {
            return this.$store.state.live_classes;
        },
        is_claim() {
            return this.$store.state.is_claim
        },
        eventPopup() {
            return this.$store.state.event_popup;
        },
    },

    watch: {
        $route() {
            this.fetch();
        },
    },

    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    created() {
        this.$store.commit("setMenuActive", "home");
        window.addEventListener('scroll', this.handleScroll);
        this.fetch();
        //window.parent.postMessage({type: 'update_item_info'});
    },

    updated() {
        //if (this.user.first_login == 1) {
        //    $("#dailyBonusModal").modal();
        //}

        //this.$nextTick(function () {
        //    document.getElementById('footer').click();
        //})
    },

    mounted() {
        //this.refreshData()
        if (!this.$store.state.user_info.childrens && this.role_type == "parent") {
            location.href = '/connect-account-home'
        }
        this.grade_selected = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade;
        setInterval(this.refreshData, 2000);

        this.$nextTick(function () {

        });
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },

    methods: {
        startCountdown(timeRemaining) {
            this.countdownTime = timeRemaining;

            // Cập nhật lần đầu tiên
            this.updateCountdown();

            // Bắt đầu đếm ngược
            this.countdownInterval = setInterval(() => {
                this.countdownTime--;
                if (this.countdownTime <= 0) {
                    clearInterval(this.countdownInterval);
                }
                this.updateCountdown();
            }, 1000);
        },
        updateCountdown() {
            const hours = Math.floor(this.countdownTime / 3600);
            const minutes = Math.floor((this.countdownTime % 3600) / 60);
            const seconds = this.countdownTime % 60;

            const formattedHours = String(hours).padStart(2, '0');
            const formattedMinutes = String(minutes).padStart(2, '0');
            const formattedSeconds = String(seconds).padStart(2, '0');

            this.countdownFormatted = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
        },
        initState() {
            const role = localStorage.getItem('role_type');
            const config = getConfigs();
            const subjects = config.subjects || [];

            const subjectsChecked = localStorage.getItem('subjects_checked');
            const subjectsCheckedArr = subjectsChecked ? subjectsChecked.split(',') : [];

            subjects.forEach((subject) => {
                if ((subjectsCheckedArr.length > 0 && subjectsCheckedArr.includes(subject.category_code)) || subjectsCheckedArr.length == 0) {
                    subject.is_checked = true;
                } else {
                    subject.is_checked = false;
                }
            });

            const programData = localStorage.getItem('program');
            let program;
            if (!localStorage.getItem('subjects_checked_1')) {
                program = {
                    id: config.programs[0].id,
                    code: config.programs[0].code,
                    name: config.programs[0].name,
                    subject: "math"
                };
            } else {
                program = programData ? JSON.parse(programData) : {
                    id: 1,
                    code: "ismart",
                    name: "iSMART",
                    subject: "math"
                };
            }

            const user_info = this.$store.state.user_info;
            let child_account = localStorage.getItem('child_account');
            child_account = child_account ? JSON.parse(child_account) : null;
            if (child_account == null && user_info.childrens) {
                child_account = user_info.childrens[0];
            }

            return {
                countdownInterval: null,
                countdownTime: 0, // Thời gian đếm ngược tính bằng giây
                countdownFormatted: '00:00:00',
                url_study: "",
                wall: false,
                hidePopup: localStorage.getItem('hide_popup') ? JSON.parse(localStorage.getItem('hide_popup')) : false,
                selectedSubject: localStorage.getItem('subjects_checked_1') ? localStorage.getItem('subjects_checked_1') : "math",
                skills: [],
                subjectProgram: [],
                child_account: child_account,
                grade_selected: localStorage.getItem('grade'),
                isLoading: false,
                lastests: [],
                maths: [],
                filter: {
                    last_study: true,
                    maths: true,
                    sciences: true,
                    english: true,
                    igs: true,
                },
                dataReport: [],
                isShowLastestStudy: true,
                subjects: subjects,
                checkedSubjects: [],
                subjectData: [],
                state: "all",
                program: program,
                programSelected: program,
                programs: config.programs || [],
                role_type: role,
                notice: "online_testing",
                tutorings: [],
                live_classes: [],
                online_testing_data: [],
                list_events: [
                    // {
                    //     "name": "Test-Import-Student",
                    //     "subject": "Round 1 - Step 1",
                    //     "start": "26/04/2024 15:00",
                    //     "end": "31/05/2024 23:59",
                    //     "url": "https://ec-dev.ismart.edu.vn/login?token=eyJhbGciOiJSUzI1NiIsImtpZCI6IkUwMzA2RjQ1ODIwNDc1OTRBNURBRUM4N0FCNkVGNUFDIiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE3MTQ3MDY2MDMsImV4cCI6MTcxNDc0MjYwMywiaXNzIjoiaHR0cHM6Ly9zc28tc3RhZ2luZy5pc21hcnQuZWR1LnZuIiwiY2xpZW50X2lkIjoiSVRPX0NsaWVudCIsInN1YiI6IjIwZjhmZWYyLWU4ZjYtNDVmNC04MDQwLWEzN2U3MmY0NjlhZiIsImF1dGhfdGltZSI6MTcxNDcwNjYwMywiaWRwIjoibG9jYWwiLCJqdGkiOiI3MDE5MDVFMkExOUQ1MjUzRUFDRUJEQTU5ODhCN0Q0NSIsImlhdCI6MTcxNDcwNjYwMywic2NvcGUiOlsiZW1haWwiLCJpc21hcnRpZCIsIm9wZW5pZCIsInByb2ZpbGUiLCJvZmZsaW5lX2FjY2VzcyJdLCJhbXIiOlsicHdkIl19.JgnFCR9G6s630qK1-zgJoBk9TEMYS2AJctusAhBEwdrtqr_UYK2zIEUEFY9LPoo3NvsTuXsv1zPn7WX_h7-Q3g1IvIVHlY3x74qEQFL55rNLHPx_vuYImatyU40bei2R8tT5k2xHbYD8xPz9YuBawoB9CjLoaWP9CuL_BTSXLx7yZDZDmRiJQSs__2gtI7ez1XXjLmM1CTUPL_O66DUituUuizZHmFto4SZXrhpYo9BZkFGoFen2FWzD5T5WHknUbCsb0FQdDSbvsjS0z6OOL_Ji8RppyD-Jk6ETNgEGoB9ywZ0dyTHBiehH7ta3NvOqZNl9yGY2RtgXUs1H9pveQQ",
                    //     "time_remaining": 5000
                    // }
                ],
                system: process.env.VUE_APP_TITLE == "MGS" ? "MGS" : "ismart",
            };
        },

        gotoUnit(subject, unit_id) {
            var path = '';
            if (subject.program == 'Eng_Test_Prep') {
                path = '/ielt/' + subject.id + '/' + unit_id + '/1';
                this.handleGACustomEvent('IP2_W_4000')
                this.$router.push({ path: path })

            } else {
                if (subject.category_code == 'math') {
                    this.handleGACustomEvent('IP2_W_1009', subject.id)
                }
                else if (subject.category_code == 'science') {
                    this.handleGACustomEvent('IP2_W_1010', subject.id)
                }
                if (this.programSelected.code == "precourse") {
                    path = '/pre/' + subject.id + '/' + unit_id + '/1';
                    this.$router.push({ path: path })
                } else {
                    path = '/unit/' + subject.id + '/' + unit_id + '/1';
                    this.$router.push({ path: path })
                }
            }
            this.handleGACustomEvent('IP2_W_1008', subject.subject_id)
        },

        handleGACustomEvent(element, id) {
            var user_id = this.user_info.user_id || 0;
            var school_id_ref = parseInt(this.user_info.school_id_ref) || 0;
            var params = {
                'w_user_id': user_id
            };

            if (element == 'IP2_W_1008') {
                params['subject_id'] = id || 0;
                params[element] = user_id + '|' + id;
            }

            else if (element == 'IP2_W_4000' || element == 'IP2_W_1009' || element == 'IP2_W_1010') {
                params['school_id'] = school_id_ref
                params[element] = user_id + '|' + school_id_ref;
            }

            else {
                params['course_id'] = id || 0;
                params[element] = user_id + '|' + id;
            }
            gtag('event', element, params);
        },

        openStudyGuide(subject) {
            this.handleGACustomEvent('IP2_W_1001', subject.id);
            this.wall = true
            this.url_study = subject.study_guide_picture_url
            $('#study_guide').modal('show');
        },

        closeStudyGuide() {
            this.wall = false
            $('#study_guide').modal('hide');
        },

        btnJoinClass(url) {
            window.open(url)
        },

        btnDoTest(url) {
            window.open(url)
        },

        hidePopupFunct() {
            localStorage.setItem('hide_popup', true)
        },

        async getParentFeedbacks() {
            const that = this;
            await axios.all([
                getParentFeedbacks({
                    user_id: that.child_account ? that.child_account.id : '',
                    parent_id: that.user_info.id
                }),
            ]).then(axios.spread((response) => {
                that.isLoading = false;
                if (response.data.code != 0) {
                    return;
                }
                that.skills = response.data.results.skills || [];
            }))
        },

        // async getListOnlineTestingV2(){
        //     return new Promise((resolve, reject) => {
        //         const header = {alg: 'HS256', typ: 'JWT'};
        //         const that = this;
        //         axios.all([
        //             getOnlineTestingV2({
        //                 token: window.localStorage.getItem('access_token')
        //             }),
        //         ]).then(axios.spread((response) => {
        //             if (!response.data.success) {
        //                 return;
        //             }

        //             const currentTime = new Date().getTime();

        //             response.data.data.forEach(test => {
        //                 const endString = (moment(test.end, "HH:mm DD/MM/YYYY").toDate()).getTime();

        //                 const startString = (moment(test.start, "HH:mm DD/MM/YYYY").toDate()).getTime();

        //                 if(startString <= currentTime && endString >= currentTime){
        //                     that.online_testing_data.push(test)
        //                 }
        //             })


        //             resolve(that.online_testing_data);
        //         }))
        //     })
        // },

        async getOnlineTestData() {
            const that = this;
            const params = {
                username: that.user_info.username,
                grade: that.user_info.grade,
            };
            axios.all([getOnlineTestData(params)]).then(
                axios.spread((response) => {
                    if (response.data.code != 200) {
                        return;
                    }
                    that.online_testing_data = [...that.online_testing_data, ...response.data.results]
                    resolve(that.online_testing_data);
                })
            );
        },

        async getEvents() {
            console.log("test event");
            axios.all([getEvents()]).then(
                axios.spread((response) => {
                    if (response.data.code != 200) {
                        return;
                    }
                    this.list_events = response.data.results
                    this.startCountdown(this.list_events[0].time_remaining)
                })
            );
        },

        async getOnlineTestDataOTV2() {
            const that = this;
            const params = {

            };
            axios.all([getOnlineTestDataOTV2(params)]).then(
                axios.spread((response) => {
                    if (response.data.code != 200) {
                        return;
                    }
                    that.online_testing_data = [...that.online_testing_data, ...response.data.results]
                    resolve(that.online_testing_data);
                })
            );
        },

        // async getListOnlineTesting(){
        //     return new Promise((resolve, reject) => {
        //         const header = {alg: 'HS256', typ: 'JWT'};
        //         const payload = {
        //             username: this.user_info.username,
        //             exp: Math.floor(Date.now() / 1000) + (12 * 60 * 60),
        //         };
        //         const secret = 'Blueocean_OT_123';

        //         const token = KJUR.jws.JWS.sign(header.alg, JSON.stringify(header), JSON.stringify(payload), secret);

        //         const that = this;
        //         axios.all([
        //             getOnlineTesting({
        //                 username: that.user_info.username,
        //                 token,
        //                 page: "1",
        //                 limit: "10",
        //             }),
        //         ]).then(axios.spread((response) => {
        //             if (!response.data.success) {
        //                 return;
        //             }

        //             const currentTime = new Date().getTime();

        //             response.data.data.forEach(test => {
        //                 const endString = (moment(test.end, "HH:mm DD/MM/YYYY").toDate()).getTime();

        //                 const startString = (moment(test.start, "HH:mm DD/MM/YYYY").toDate()).getTime();

        //                 if(startString <= currentTime && endString >= currentTime){
        //                     that.online_testing_data.push(test)
        //                 }
        //             })

        //             resolve(that.online_testing_data);
        //         }))
        //     })
        // },

        async getListTutoring(month, year) {
            const that = this;
            await axios.all([getTutorings({
                month: month,
                year: year
            })]).then(
                axios.spread((response) => {
                    that.$store.commit("setLoading", false);
                    if (response.data.code != 0) {
                        that.tutorings = [];
                        return;
                    }
                    try {
                        that.tutorings = response.data.results ? response.data.results.class : [];
                        that.live_classes = response.data.results ? response.data.results.class : [];
                        this.$store.commit("setLiveClasses", response.data.results ? response.data.results.class : []);
                        this.$nextTick(function () {
                            var swiper = new Swiper(".mySwiper", {
                                slidesPerView: 2,
                                //centeredSlides: true,
                                spaceBetween: 20,
                                pagination: {
                                    el: ".swiper-pagination",
                                    type: "fraction",
                                },
                                navigation: {
                                    nextEl: ".swiper-button-next",
                                    prevEl: ".swiper-button-prev",
                                },
                            });
                        });
                    } catch (error) {
                        console.error(error);
                    }
                })
            );
        },


        async getTutoringsInComming(hours) {
            return new Promise((resolve, reject) => {
                const that = this;
                axios.all([getTutoringsInComming({
                    hours: hours
                })]).then(
                    axios.spread((response) => {
                        that.$store.commit("setLoading", false);
                        if (response.data.code != 0) {
                            that.tutorings = [];
                            return;
                        }
                        try {
                            that.tutorings = response.data.results ? response.data.results.class : [];
                            that.live_classes = response.data.results ? response.data.results.class : [];

                            let listClasses = [];

                            that.live_classes.forEach(e => {
                                if (e.status != 4) {
                                    listClasses.push(e);
                                }
                            })
                            this.$store.commit("setLiveClasses", listClasses ? listClasses : []);
                            resolve(listClasses)
                            this.$nextTick(function () {
                                var swiper = new Swiper(".mySwiper", {
                                    slidesPerView: 2,
                                    //centeredSlides: true,
                                    spaceBetween: 20,
                                    pagination: {
                                        el: ".swiper-pagination",
                                        type: "fraction",
                                    },
                                    navigation: {
                                        nextEl: ".swiper-button-next",
                                        prevEl: ".swiper-button-prev",
                                    },
                                });
                            });
                        } catch (error) {
                            console.error(error);
                        }
                    })
                );
            })
        },

        changeProgram(program, subject = "", ismart = false, subject1) {
            this.program = program;
            this.programSelected = program;
            if (ismart) {
                this.program.subject = subject
                this.selectedSubject = subject
                window.localStorage.setItem('subjects_checked_1', this.selectedSubject)
            } else {
                this.selectedSubject = "all"
                window.localStorage.setItem('subjects_checked_1', 'all')
            }

            this.$forceUpdate()
            console.log(this.program);
            // localStorage.setItem('first_login', false);
            localStorage.setItem('program', JSON.stringify(this.program));

            window.boChatbot?.setContext('subject', this.program.subject || this.program.name)
            window.boChatbot?.deleteContext('unit')
            window.boChatbot?.deleteContext('lesson')
            window.boChatbot?.deleteContext('module')
        },

        changeNotice(notice) {
            this.notice = notice
            // if(this.notice == 'live_class'){
            //     this.notice = 'online_testing';
            // }else{
            //     this.notice = 'live_class';
            // }

            this.$nextTick(function () {
                var swiper = new Swiper(".mySwiper", {
                    slidesPerView: 2,
                    //centeredSlides: true,
                    spaceBetween: 20,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "fraction",
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
            });
        },

        getProgramClass(program, index) {
            const i = index + 1;

            if (program.id == this.programSelected.id) {
                return 'item-program active';
            }

            return 'item-program';
        },
        getProgramImageUrl(program, index) {
            // const i = index + 1;
            // const x = i % 2;

            // return x == 0?'/themes/web/assets/images/program-2.svg':'/themes/web/assets/images/program-1.svg';
        },

        checkSubject: function (e) {
            this.getSoundClick();

            updateCheckedSubjects(this.checkedSubjects);
        },

        resetState() {
            Object.assign(this.$data, this.initState());
        },

        resetSearching() {
            this.resetState();

            this.fetch();
        },

        async fetch(page = 1) {
            await this.getAllUnits();

            await this.getLastStudy();

            await this.getEvents();

            if (this.role_type == "parent") {
                await this.getParentReportGrade();
            }

            await this.getParentFeedbacks();

            // this.getListTutoring('07','2022');

            let liveclass = await this.getTutoringsInComming(300);
            let testing = await this.getOnlineTestData()
            testing = await this.getOnlineTestDataOTV2()


            if (testing?.length > 0 && liveclass.length == 0) {
                this.notice = "online_testing"
            }

            this.$nextTick(function () {
                var swiper = new Swiper(".mySwiper", {
                    slidesPerView: 2,
                    //centeredSlides: true,
                    spaceBetween: 20,
                    pagination: {
                        el: ".swiper-pagination",
                        type: "fraction",
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                });
            });
        },

        selectSubject(sub) {
            const subjectSelected = [];
            this.subjects.forEach((subject) => {
                if (sub.category_code == subject.category_code && !sub.is_checked) {
                    subject.is_checked = false
                } else if (sub.category_code == subject.category_code && sub.is_checked) {
                    subject.is_checked = true
                }
                if (subject.is_checked) {
                    subjectSelected.push(subject.category_code);
                }
            });

            this.checkedSubjects = subjectSelected;

            window.localStorage.setItem('subjects_checked', this.checkedSubjects)
        },

        showSelectProgramForm() {
            $('#selectProgramModal').modal('show');
        },

        selectProgram(program) {
            this.programSelected = program;

            //console.log(program);
        },

        saveProgram() {
            this.program = this.programSelected;

            //console.log(program);

            localStorage.setItem('program', JSON.stringify(this.program));

            $('#selectProgramModal').modal('hide');
        },

        isShowCourse(p) {
            return this.subjectData.some(subject =>
                subject.program == p.code &&
                subject.require_subject == 0 &&
                subject.id > 0 &&
                subject.units &&
                subject.units.length > 0
            );
        },

        isShowSubject(subject) {
            return subject.program == this.program.code;
            //return subject.category_code == this.program.code;
        },

        isShowSubjectFilter() {
            let program = localStorage.getItem('program');

            program = JSON.parse(program);

            if (program == null) {
                return true;
            }

            if (program.code == this.system) {
                return true;
            }

            return false;
        },

        async getLastStudy() {
            let arrCodeProgram = []
            let listProgram = JSON.parse(localStorage.getItem('configs')).programs
            listProgram.forEach(p => {
                arrCodeProgram.push(p.code)
            })
            const that = this;
            const params = {
                // program: JSON.stringify(arrCodeProgram),
                grade: 1,
            };
            await axios.all([getAllLastest(params)]).then(
                axios.spread((lastest_response) => {
                    that.isLoading = false;

                    if (lastest_response.data.code != 0) {
                        that.isShowLastestStudy = false;
                        return;
                    }
                    that.lastests = lastest_response.data.results || [];

                    const lang = localStorage.getItem('lang') || 'vi';


                    that.lastests.forEach(e => {
                        e.time_ago_txt = moment.unix(e.time).locale(lang).fromNow();
                        e.time_txt = moment.unix(e.time).locale(lang).format("hh:mm ddd, DD MMM, YYYY");
                        if (e.process == 0) {
                            this.$store.commit("setLasted", true);
                        }
                        if (e.process == 0 && !that.hidePopup) {
                            if (this.user.first_login == 0 && true) {
                                $('#popupContinueLesson').modal('show')
                            }
                        }
                    })

                    // that.lastests.time_ago_txt = moment.unix(that.lastests.time).locale(lang).fromNow();
                    // that.lastests.time_txt = moment.unix(that.lastests.time).locale(lang).format("hh:mm ddd, DD MMM, YYYY");

                    // that.$nextTick(function() {
                    //     var initNanoScroller = function() {
                    //         if ($('.nano').length > 0) {
                    //             $(".nano").nanoScroller();
                    //         }
                    //     }
                    //     initNanoScroller();

                    //     //$('body').css({'overflow-y':'hidden'})
                    // })
                })
            );
        },
        handleScroll(event) {
            // if(window.top.scrollY>290){
            //     document.getElementById("filter-fixed").style ="position:fixed;z-index:100; top:51px; border-radius:5px; width:945px; background-color:#4a8ded; padding:10px 10px 10px 0"
            // }
            // else{
            //     document.getElementById("filter-fixed").style =""
            // }
        },
        async getParentReportGrade() {
            const params = {
                grade: this.child_account ? this.child_account.grade : this.user_info.grade,
                role: this.role_type,
                student_id: this.child_account ? this.child_account.id : 0
            };
            await axios.all([
                getParentReportGrade(params),
            ]).then(axios.spread((report_response) => {
                this.isLoading = false;
                this.$store.commit("setLoading", false);
                if (report_response.data.code != 0) {
                    return;
                }
                this.dataReport = report_response.data.results.program || [];
            }));
        },
        async getAllUnits() {
            const that = this;
            const params = {
                grade: that.user.grade,
            };
            await axios.all([getAllUnit(params)]).then(
                axios.spread((response) => {
                    if (response.data.code != 0) {
                        return;
                    }

                    const subjectsChecked = localStorage.getItem('subjects_checked');
                    const subjectsCheckedArr = subjectsChecked ? subjectsChecked.split(',') : [];

                    that.subjectData = response.data.results.subjects || [];

                    let checkedSubjects = getCheckedSubjects();
                    if (checkedSubjects.length == 0) {
                        that.subjectData.forEach((item) => {
                            if ((subjectsCheckedArr.length > 0 && subjectsCheckedArr.includes(item.category_code)) || subjectsCheckedArr.length == 0) {
                                checkedSubjects.push(item.category_code);
                            }
                        });
                    }
                    that.checkedSubjects = checkedSubjects;

                    let subjectProgram = []
                    that.subjectData.forEach((e, index) => {
                        subjectProgram.push({ "url_study": e.study_guide_picture_url, "program": e.program, "category_code": e.category_code, "name": e.subject_name, "id": index })
                    })

                    that.subjectData.forEach((sbj) => {
                        sbj.show_final_test = 1;
                        if (that.user) {
                            if (that.user.final_test_grade) {
                                that.user.final_test_grade.forEach(function (e) {
                                    if (e.subject_id == sbj.subject_id && that.user_info.grade == e.grade) {
                                        sbj.show_final_test = 0;
                                    }
                                })
                            }
                        }
                        that.subjectProgram.push(sbj);
                    })


                    that.subjectProgram = subjectProgram
                    that.subjects = subjectProgram

                    that.subjects.forEach((subject) => {
                        subject.is_checked = true;
                    });


                    console.log(that.subjectProgram, that.subjects);

                    window.boChatbot?.setContext('subject', that.program.subject || that.program.name)
                    window.boChatbot?.deleteContext('unit')
                    window.boChatbot?.deleteContext('lesson')
                    window.boChatbot?.deleteContext('module')
                })
            );
        },

        async getListUnits() {
            const that = this;
            const params = {
                subject: "math",
                grade: 1,
            };
            await axios.all([getListUnit(params)]).then(
                axios.spread((list_unit_response) => {
                    that.isLoading = false;
                    if (list_unit_response.data.code != 0) {
                        return;
                    }
                    that.maths = list_unit_response.data.results || [];
                })
            );
        },

        changeState(state) {
            this.getSoundClick();

            this.state = state;
        },

        getSoundClick() {
            soundClick();
        },
        upgradeAccount(a) {
            // if (this.user.placement_test != 0){
            //     $('#popupUpgradeAccount').modal('show');
            // }else{
            //     $('#placementModal').modal('show');
            // }
        },
        doTest() {
            $('#popupUpgradeAccount').modal('hide');
            $('#placementModal').modal('show');
        },
        calcPercent(process, total) {
            return toPercent(process, total);
        },
        timeConverter(UNIX_timestamp) {
            var a = new Date(UNIX_timestamp * 1000);
            var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
            var year = a.getFullYear();
            var month = months[a.getMonth()];
            var date = a.getDate();
            var hour = a.getHours();
            var min = a.getMinutes();
            var sec = a.getSeconds();
            var time = date + '/' + month + '/' + year + ' - ' + hour + ':' + min + ':' + sec;
            return time;
        }
    },
};
</script>

<style scoped>
.modal-backdrop {
    z-index: 2000 !important;
}

#study_guide {
    position: absolute;
    z-index: 3000;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}

#study_guide .modal-body {
    position: relative;
    /* background-color: red; */
    padding: 0;
    border-radius: 8px;
    box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.15);
    overflow: hidden;
}

#study_guide .modal-dialog {
    max-width: none !important;
}

#study_guide .modal-dialog img {
    width: 100%;
    height: 100%;
}

.close-study {
    position: absolute;
    width: 20px;
    z-index: 999;
    right: 0;
    cursor: pointer;
}

.ebook-link {
    font-size: 13px;
    display: flex;
    align-items: center;
    background: #00A3FF;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #00A3FF;
    border-radius: 8px;
    padding: 8px 12px 8px 12px;
    /* width: 117px; */
    width: fit-content;
    height: 32px;
    color: #FFFFFF;
}

.progress-process {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%), #40C0F6;
}

#popupContinueLesson .modal-content {
    border-radius: 16px;
}

.lock-unit:after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
}

.lock-unit {
    position: relative;
}

.lock-unit .lock-image {
    position: absolute;
    z-index: 10;
    top: 50%;
    left: 0;
    right: 0;
    margin: auto;
    transform: translateY(-50%);
}

/* #p_scroll .nano-content .card:first-child{
        margin-top: 0;
    } */

.nano-content .card-title {
    font-weight: 700;
}

.course-block .card-body {
    /* padding-top: 30px ;
        padding-bottom: 30px;
        display: flex;
        flex-wrap: wrap;
        column-gap: 12px;
        row-gap: 20px; */
    /* width: 968px; */
    /* margin-left: 12px; */

    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 12px;
    grid-row-gap: 20px;
}

.course-item {
    /* height: 188px; */
    width: 240px;
    /* margin-bottom: 20px; */
}

.thumb-study {
    border: 1px solid #CCD2E3;
    box-shadow: none !important;
}

.course-item .thumb-study-thumb-info {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 0;
    height: 56px;
    text-align: center;
    border-radius: 0 0 4px 4px;
}

.course-item .thumb-study-thumb-info-title {
    color: #1E263C;
    font-weight: bold;
    width: 150px;
}

.course-item .thumb-study-thumb-info-title h4 {
    padding: 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.course-item .thumb-content {
    height: 160px;
    /* width: 100%; */
}

.thumb-content .thumb-img {
    border-radius: 4px 4px 0px 0px;
}

.thumb.r16x9 {
    height: 160px;
}

.thumb.r16x10 {
    /* height: 152px; */
    height: 160px;
    width: 240px;
}

.container-main {
    /* width: 944px; */
    width: 1096px;
    padding: 0;
    margin: auto;
}

.show-course {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 12px;
    justify-content: space-between;
    height: 43px;
    background: #FFFFFF;
    border-radius: 8px;
}

.show-course p {
    margin: 0;
    font-size: 12px;
    height: 100%;
    display: flex;
    align-items: center;
    color: #0D0D0C;
    line-height: 43px;
    font-weight: bold;
    margin: 0 6px;
}

.box-filter {
    margin: 30px 0 0;
    display: flex;
    height: 43px;
    /* position: fixed;
        z-index: 9999; */
}

.box-filter-detail {
    height: 43px;
    margin-left: 12px;
}

.box-filter-detail .checkbox {
    margin-right: 8px;
}

.box-filter-detail ul li:last-child .checkbox {
    margin-right: 0 !important;
}

.box-filter-detail ul li:last-child {
    margin-right: 0 !important;
}

#main {
    padding-bottom: 0 !important;
}

.nano-content {
    height: 100%;
}

#selectProgramModal .modal-dialog {
    width: 366px;

}

#selectProgramModal .modal-content {
    padding: 20px 40px 30px;
    border-radius: 8px;
}

#selectProgramModal .modal-header {
    padding: 0 0 35px;
    font-size: 20px;
}

#selectProgramModal .modal-header .modal-title {
    font-size: 20px;
}

#selectProgramModal .item-program {
    display: flex;
    padding: 14px 24px;
    border-radius: 8px;
    background: #E5F1F7;
    font-size: 16px;
    color: #0D0D0C;
    display: flex;
    justify-content: space-between;
    margin-bottom: 14px;
    cursor: pointer;
    align-items: center;
    font-weight: 700;
}

/* #selectProgramModal .item-program:last-child{ */
/* margin-bottom: 27px; */
/* } */

#selectProgramModal .item-program.active {
    background: #43ABFF;
    color: #FFFFFF;
}

#selectProgramModal .modal-body {
    padding: 0;
}

/* #selectProgramModal .item-program img{
    } */

#selectProgramModal .modal-footer {
    padding: 13px 0 0;
}

#selectProgramModal .modal-footer button {
    font-size: 14px;
}

#selectProgramModal .modal-header .btn-close {
    right: 20px !important;
}

#popupContinueLesson .btn-close {
    box-sizing: content-box;
    width: 30px;
    height: 30px;
    padding: 0.25em 0.25em;
    background: transparent url("/public/themes/ito/images/icon-closed.svg") center/18px auto no-repeat;
    border: 0;
    border-radius: 0.25rem;
    opacity: 1;
    position: absolute;
    right: 0;
    top: 0;
}

#filter-fixed.sticky .card-live-alert {
    display: none;
}

.card-live-alert .carousel-control-next {
    right: -20px;
    width: auto;
}

.card-live-alert .carousel-control-prev {
    left: -20px;
    width: auto;
}

.card-live-alert .card-live-alert-item {
    padding: 12px 20px;
    background: #FFFFFF;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.07);
    border-radius: 4px;
}

.card-live-alert .card-live-alert-item>p {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: #1B1B1B;
    margin-bottom: 4px;
}

.card-live-alert .card-live-alert-item>.title {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #00A3FF;
    margin-bottom: 4px;
}

.card-live-alert .carousel-inner {
    padding: 4px;
}

.card-live-alert .card-content {
    position: relative;
    max-height: 550px;
    overflow-x: hidden;
    padding: 20px 30px;
}

.card-live-alert .card-content:hover .mySwiper .swiper-button-prev {
    display: block;
}

.card-live-alert .card-content:hover .mySwiper .swiper-button-next {
    display: block;
}

.mySwiper .swiper-button-next,
.mySwiper .swiper-container-rtl .swiper-button-prev {
    background-image: none;
    right: -5px;
    left: auto;
    display: none;
}

.mySwiper .swiper-button-prev,
.mySwiper .swiper-container-rtl .swiper-button-next {
    background-image: none;
    left: 5px;
    right: auto;
    display: none;
}

.mySwiper {
    overflow: hidden;
    padding-bottom: 5px;
}

.live-class-report .class-item-col-1 .desc {
    font-size: 12px;
}

.card-title .desc-time {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: #171717;
}

.card-title .desc-time>b {
    font-weight: 700;
}

.btn-join-class {
    background: linear-gradient(180deg, #A7DF3D 0%, #96DB16 100%);
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.07);
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    color: #FFFFFF;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-class-finish {
    border: 1px solid #979797;
    box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.07);
    border-radius: 4px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    color: #1B1B1B;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-title .buttons>.btn-group button {
    padding: 8px 20px;
    vertical-align: middle;
}

.card-title .buttons>.btn-group button.active {
    background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
    box-shadow: inset 0px 2px 0px rgba(255, 255, 255, 0.2);
    border-radius: 8px;
}

.card-tutoring .live-class-report .report-1 {
    padding: 0;
    background: transparent;
    box-shadow: none;
    border-radius: 0;
    margin-right: 34px;
}

.live-class-report h4 {
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #00A3FF;
}

.live-class-report .class-item-col-2 .btn {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #FFFFFF;
}

.live-class-report .class-item-col-2 .btn.btn-class-finish {
    color: #979797;
}

.live-class-dot {
    width: 8px;
    display: inline-block;
    height: 8px;
    background: red;
    border-radius: 100%;
    margin: 0 4px 0 5px;
}

.live-class-text {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: #FA450F;
}

.live-class-report .class-item-content {
    display: block;
    position: relative;
    align-items: center;
}

.live-class-menu {
    position: relative;
}

.live-class-alert {
    background: #FFFFFF;
    box-shadow: 4px 4px 0px rgb(0 0 0 / 7%), inset 0px 4px 0px rgb(231 231 231 / 25%);
    border-radius: 8px;
    padding: 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: #000000;
    position: absolute;
    top: 2px;
    left: 100%;
    width: 160px;
    margin-left: 2px;
}

.live-class-alert {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: #000000;
}

.live-class-alert-title {
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: #1B1B1B;
    margin-bottom: 4px;
}

.live-class-alert .live-class-dot {
    margin-left: 0;
}

.card>.card-body>.card-title {
    padding: 7px 30px;
    margin: 0;
    box-shadow: inset 0px 2px 0px rgba(255, 255, 255, 0.5);
    background: #FFE39B;
    border-radius: 4px 4px 0px 0px;
    /* height: 44px; */
}

.card>.card-body>.card-title>span.title {
    font-family: 'Nunito', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 27px;
    color: #171717;
}

.card-title {
    display: flex;
}

.card-title>span.title {
    display: flex;
    align-self: center;
    flex: 1;
}

.card-live-alert .card-body {
    padding: 0;
}

.no-availabel-text {
    text-align: center;
    font-weight: 400;
    font-size: 20px;
    color: #171717;
    display: flex;
    justify-content: center;
    height: 143px;
    margin-bottom: 0;
    align-items: center;
}


/* .ito-tabs a.active {
        color: #fff;
        background: #F7A706;
        box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
    } */
.ito-tabs {
    margin-top: 0;
    font-size: 14px;
    padding: 0px;
    list-style: none;
    background: rgba(255, 255, 255, 0.56);
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07), inset 0px 4px 0px rgba(231, 231, 231, 0.25);
    display: inline-block;
    border-radius: 8px;
    position: relative;
}

.ito-tabs a {
    text-decoration: none;
    color: rgba(0, 0, 0, 0.5);
    padding: 0px 15px;
    display: inline-block;
    position: relative;
    z-index: 1;
    transition-duration: 0.1s;
    height: 37px;
    line-height: 38px;
    font-size: 14px;
    font-weight: 600;
}

.ito-tabs a.active {
    color: #fff;
    background: #5AC9F7;
    box-shadow: 4px 4px 0px rgb(0 0 0 / 5%);
    border-radius: 8px;
}

#box-filter-c .ito-tabs a.active {
    color: #000;
    background: #F7A706 !important;
    box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
}

#box-filter-c .ito-tabs {
    background: #ffffff !important;
}

#box-filter-c .ito-tabs a {
    height: 50px;
    line-height: 50px;
    font-size: 14px;
}

.wall {
    z-index: 1200;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    opacity: 0.5;
    background-color: #000;
}

#swiper-event {
    display: flex;
    justify-content: space-between;
    padding: 12px;
    padding-right: 0;
    background: #002880;
}

#swiper-event .title {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-align: left;
    color: #F04923;
    margin-bottom: 10px;
}

#swiper-event .desc {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.02em;
    text-align: left;
    margin-bottom: 10px
}

#swiper-event button {
    background: #fff;
    width: Fixed (390px)px;
    height: (24px)px;
    padding: 4px 20px 4px 20px;
    border-radius: 32px;
    border: 1px solid black;
}</style>